import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X } from "lucide-react";

export default function SearchOverlay({ open, onClose }) {
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      setTimeout(() => inputRef.current?.focus(), 50);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    if (open) window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  const onSubmit = (e) => {
    e.preventDefault();
    const q = inputRef.current?.value.trim();
    if (q) {
      navigate(`/buscar?q=${encodeURIComponent(q)}`);
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[80] flex items-start justify-center"
      style={{ background: "rgba(0,0,0,0.85)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
      data-testid="search-overlay"
    >
      <div
        className="w-full max-w-2xl mx-auto mt-[15vh] px-5"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={onSubmit} className="relative">
          <Search size={22} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/70" />
          <input
            ref={inputRef}
            type="text"
            placeholder="Buscar noticias, artistas, eventos..."
            data-testid="search-overlay-input"
            className="w-full bg-white/10 border-2 border-white/20 text-white text-lg md:text-2xl placeholder:text-white/50 rounded-full py-4 pl-12 pr-14 focus:outline-none focus:border-white/60 transition"
            autoComplete="off"
          />
          <button
            type="button"
            onClick={onClose}
            data-testid="search-overlay-close"
            className="absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-full text-white/70 hover:text-white hover:bg-white/10 transition"
            aria-label="Cerrar"
          >
            <X size={22} />
          </button>
        </form>
        <p className="text-center text-xs text-white/50 mt-4 uppercase tracking-wider font-bold">
          Presioná <kbd className="px-1.5 py-0.5 rounded bg-white/10">Enter</kbd> para buscar
        </p>
      </div>
    </div>
  );
}
